(() => {
  'use strict';

  const root = document.querySelector('[data-bazaar-future-commerce]');
  if (!root) return;

  const dialog = root.querySelector('[data-bazaar-command-dialog]');
  const input = root.querySelector('[data-bazaar-command-input]');
  const form = root.querySelector('[data-bazaar-command-form]');
  const status = root.querySelector('[data-bazaar-command-status]');
  const spatialDialog = root.querySelector('[data-bazaar-spatial-dialog]');
  const spatialStatus = root.querySelector('[data-bazaar-spatial-status]');
  const currentModelButton = root.querySelector('[data-bazaar-view-current-model]');

  const routes = {
    search: root.dataset.searchUrl || '/search',
    minerals: root.dataset.mineralsUrl || '/collections',
    newest: root.dataset.newUrl || '/collections/all?sort_by=created-descending',
    contact: root.dataset.contactUrl || '/',
    cart: root.dataset.cartUrl || '/cart'
  };

  const showDialog = target => {
    if (!target) return;
    try { if (typeof target.showModal === 'function') target.showModal(); else target.setAttribute('open', ''); }
    catch (_) { target.setAttribute('open', ''); }
  };
  const closeDialog = target => {
    if (!target) return;
    try { if (typeof target.close === 'function') target.close(); else target.removeAttribute('open'); }
    catch (_) { target.removeAttribute('open'); }
  };

  const openCommand = seed => {
    showDialog(dialog);
    if (typeof seed === 'string') input.value = seed;
    window.setTimeout(() => input?.focus({ preventScroll: true }), 0);
  };

  const room = name => {
    closeDialog(dialog);
    if (window.HiddenBazaarRooms?.open) return window.HiddenBazaarRooms.open(name);
    return false;
  };

  const normalize = value => (value || '').trim().replace(/\s+/g, ' ');
  const lower = value => normalize(value).toLowerCase();

  function parsePrice(text) {
    const under = text.match(/(?:under|below|less than|up to|max(?:imum)?)[\s$]*([0-9]+(?:\.[0-9]{1,2})?)/i);
    const over = text.match(/(?:over|above|more than|min(?:imum)?)[\s$]*([0-9]+(?:\.[0-9]{1,2})?)/i);
    return {
      max: under ? under[1] : null,
      min: over ? over[1] : null
    };
  }

  function cleanSearchText(text) {
    return normalize(text)
      .replace(/(?:show me|find me|find|search for|search|shop for|shop|browse|look for|i want|please)/ig, ' ')
      .replace(/(?:under|below|less than|up to|max(?:imum)?|over|above|more than|min(?:imum)?)[\s$]*[0-9]+(?:\.[0-9]{1,2})?/ig, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function goSearch(text) {
    const query = cleanSearchText(text) || normalize(text);
    const price = parsePrice(text);
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('type', 'product');
    if (price.max) params.set('filter.v.price.lte', price.max);
    if (price.min) params.set('filter.v.price.gte', price.min);
    window.location.assign(`${routes.search}?${params.toString()}`);
  }

  function currentProductData() {
    const node = document.querySelector('[data-current-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return null; }
  }

  function execute(raw) {
    const text = lower(raw);
    if (!text) {
      status.textContent = 'Type a mineral, locality, service, or shopping command.';
      return;
    }

    status.textContent = '';

    if (/\b(add|put) (this |the )?(item |specimen |product )?(to|in) (my )?(cart|satchel)\b/.test(text)) {
      const productForm = document.querySelector('[data-product-root] form[action*="/cart/add"]');
      const addButton = productForm?.querySelector('[data-add-button]');
      if (productForm && addButton && !addButton.disabled) {
        closeDialog(dialog);
        if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit(addButton);
        else productForm.submit();
        return;
      }
      status.textContent = 'Open an available product first, then say “add this to cart.”';
      return;
    }
    if (/\b(similar|more like this|similar specimens?|similar minerals?)\b/.test(text)) {
      const data = currentProductData();
      if (data) {
        const phrase = [data.mineral, data.variety, data.locality].filter(Boolean).join(' ') || data.title;
        return goSearch(phrase);
      }
    }
    if (/^(cart|satchel|view cart|open cart)$/.test(text)) return window.location.assign(routes.cart);
    if (/\b(visit|hours|directions|contact|location|penryn)\b/.test(text)) return window.location.assign(routes.contact);
    if (/\b(new|latest|fresh|recent)\b/.test(text) && /\b(mineral|rock|specimen|find)\b/.test(text)) return window.location.assign(routes.newest);
    if (/^(rocks?|minerals?|rocks? and minerals?|rock & mineral shop|mineral shop)$/.test(text)) return window.location.assign(routes.minerals);
    if (/\blapidary rough\b/.test(text)) return goSearch(raw);
    if (/\b(class|classes|learn|lesson|course|lapidary 101|cabochon class)\b/.test(text)) return room('classes');
    if (/\b(story|history|family story|our story)\b/.test(text)) return room('story');
    if (/\b(service|services|rock cutting|stone cutting|polish|polishing|lapidary|rock id|identify|identification|bench rental|repair|recovery)\b/.test(text)) return room('services');
    if (/\b(spatial|3d|vr|virtual reality|headset|ar|augmented reality)\b/.test(text)) {
      const model = currentProductModel();
      if (model && !spatialDialog) {
        closeDialog(dialog);
        model.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (spatialDialog) {
        closeDialog(dialog);
        return openSpatial();
      }
    }

    goSearch(raw);
  }

  document.addEventListener('click', event => {
    const open = event.target.closest('[data-bazaar-command-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      openCommand(open.dataset.bazaarCommandSeed || '');
      return;
    }
    const close = event.target.closest('[data-bazaar-command-close]');
    if (close) {
      event.preventDefault();
      closeDialog(dialog);
      return;
    }
    const example = event.target.closest('[data-bazaar-command-example]');
    if (example) {
      const phrase = example.dataset.bazaarCommandExample || '';
      input.value = phrase;
      execute(phrase);
    }
  }, true);

  document.addEventListener('keydown', event => {
    const isK = event.key?.toLowerCase() === 'k';
    if (isK && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      openCommand();
      return;
    }
    if (event.key === 'Escape' && dialog?.open) closeDialog(dialog);
  });

  form?.addEventListener('submit', event => {
    event.preventDefault();
    execute(input.value);
  });

  // Voice is progressive enhancement only. The button remains hidden when unsupported.
  const voiceButton = root.querySelector('[data-bazaar-voice]');
  const voiceLabel = root.querySelector('[data-bazaar-voice-label]');
  const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (voiceButton && Recognition) {
    voiceButton.hidden = false;
    let listening = false;
    const recognition = new Recognition();
    recognition.lang = document.documentElement.lang || 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    recognition.onstart = () => {
      listening = true;
      voiceButton.setAttribute('aria-pressed', 'true');
      if (voiceLabel) voiceLabel.textContent = 'Listening';
      status.textContent = 'Listening…';
    };
    recognition.onend = () => {
      listening = false;
      voiceButton.setAttribute('aria-pressed', 'false');
      if (voiceLabel) voiceLabel.textContent = 'Speak';
    };
    recognition.onerror = () => { status.textContent = 'Voice input was unavailable. You can type the same command.'; };
    recognition.onresult = event => {
      const phrase = event.results?.[0]?.[0]?.transcript || '';
      input.value = phrase;
      status.textContent = `Heard: “${phrase}”`;
      execute(phrase);
    };
    voiceButton.addEventListener('click', event => {
      event.preventDefault();
      if (listening) recognition.stop();
      else {
        try { recognition.start(); }
        catch (_) { status.textContent = 'Voice input is already active.'; }
      }
    });
  }

  function currentProductModel() {
    return document.querySelector('.product-gallery model-viewer, .product-gallery [data-shopify-model3d-id], .product-gallery .shopify-model-viewer-ui');
  }

  async function openSpatial() {
    if (!spatialDialog) return;
    showDialog(spatialDialog);
    const model = currentProductModel();
    if (currentModelButton) currentModelButton.hidden = !model;
    if (spatialStatus) {
      if (navigator.xr?.isSessionSupported) {
        try {
          const supported = await navigator.xr.isSessionSupported('immersive-vr');
          spatialStatus.textContent = supported
            ? 'Headset-capable browser detected. 3D product media can form the bridge into future immersive rooms.'
            : 'Spatial foundation active. This device will use standard 3D/AR product media where available.';
        } catch (_) {
          spatialStatus.textContent = 'Spatial foundation active. 3D product media appears where available.';
        }
      } else {
        spatialStatus.textContent = model
          ? '3D product media is available on this page. Full headset mode is not exposed by this browser.'
          : 'This browser will use the standard storefront. 3D controls appear automatically on supported products.';
      }
    }
  }

  document.addEventListener('click', event => {
    if (event.target.closest('[data-product-model-jump]')) {
      event.preventDefault();
      const model = currentProductModel();
      model?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => model?.focus?.({ preventScroll: true }), 450);
      return;
    }
    if (event.target.closest('[data-bazaar-spatial-open]')) {
      event.preventDefault();
      closeDialog(dialog);
      openSpatial();
      return;
    }
    if (event.target.closest('[data-bazaar-spatial-close]')) {
      event.preventDefault();
      closeDialog(spatialDialog);
      return;
    }
    if (event.target.closest('[data-bazaar-view-current-model]')) {
      event.preventDefault();
      closeDialog(spatialDialog);
      const model = currentProductModel();
      model?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => model?.focus?.({ preventScroll: true }), 450);
    }
  }, true);

  [dialog, spatialDialog].forEach(target => target?.addEventListener('click', event => {
    if (event.target === target) closeDialog(target);
  }));

  window.HiddenBazaarExplore = { open: openCommand, execute, spatial: openSpatial };
})();
